import typeCheck from 'common/util/typeCheck';

// Shared implementation for the per-PMS unit-type client actions (Rent Manager,
// Rentvine). Each provider keeps its own thin action file because the action
// registry derives its keys from filenames (require.context + es6-requireindex).

// Live fetch from the PMS — no state caching so the partner always sees current data.
export function buildGetPmsUnitTypesAction(actionType) {
  return async function getPmsUnitTypes(
    { state, utilityApiClient },
    { utilityPartnerId, onSuccess, onError },
  ) {
    typeCheck('utilityPartnerId::PositiveNumber', utilityPartnerId);

    return utilityApiClient.postWithState({
      action: actionType,
      queryId: `${utilityPartnerId}`,
      state: state,
      payload: {
        utilityPartnerId,
      },
      onSuccess: onSuccess,
      onError: onError,
    });
  };
}

// Live fetch of a housing type's units (paginated; unitTypeName omitted = untyped
// bucket). The queryId includes type + offset so concurrent expands of different rows
// aren't deduped against each other by postWithState.
export function buildGetPmsUnitTypeUnitsAction(actionType) {
  return async function getPmsUnitTypeUnits(
    { state, utilityApiClient },
    { utilityPartnerId, unitTypeName, offset, limit, onSuccess, onError },
  ) {
    typeCheck('utilityPartnerId::PositiveNumber', utilityPartnerId);

    return utilityApiClient.postWithState({
      action: actionType,
      queryId: `${utilityPartnerId}:${unitTypeName ?? '__untyped__'}:${offset ?? 0}`,
      state: state,
      payload: {
        utilityPartnerId,
        unitTypeName,
        offset,
        limit,
      },
      onSuccess: onSuccess,
      onError: onError,
    });
  };
}
